// frontend/src/components/OverloadedModal.js
import React from 'react';
import './CreditPurchaseModal.css'; // Reuse the existing modal styles

const OverloadedModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content credit-purchase-modal">
        <h2 className="text-xl font-semibold mb-4">Service Currently Overloaded</h2>
        
        <div className="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <div className="flex items-start">
            <svg className="h-6 w-6 text-amber-600 mr-3 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <div>
              <p className="text-amber-800 font-medium mb-2">The translation service is currently experiencing high demand.</p>
              <p className="text-amber-700">Our servers are processing a high volume of translation requests right now. This is a temporary situation.</p>
            </div>
          </div>
        </div>
        
        <div className="mb-6">
          <h3 className="font-medium mb-2">What you can do:</h3>
          <ul className="list-disc pl-5 space-y-1 text-gray-600">
            <li>Wait a few minutes and try again</li>
            <li>Try translating smaller batches</li>
            <li>Save your work and come back later</li>
          </ul>
        </div>
        
        <div className="text-center">
          <button
            onClick={onClose}
            className="btn btn-primary"
          >
            Understood
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverloadedModal;